import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideOptimus } from '@openng/optimus-ui/config';
import { MessageService } from '@openng/optimus-ui/api';
import Aura from '@openng/optimus-ui-themes/aura';
import { provideApiConfiguration } from '../api/api-configuration';
import { routes } from './app.routes';
import { AuthService } from './core/auth.service';
import { authInterceptor } from './core/auth.interceptor';
import { environment } from '../environments/environment';
import { getDeploymentEnvironment } from './core/deployment-environment';

const APP_TITLE = 'Admin';

function setDocumentTitle(): void {
  const { label } = getDeploymentEnvironment();
  inject(Title).setTitle(label ? `${APP_TITLE} ${label}` : APP_TITLE);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideOptimus({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideApiConfiguration(environment.apiUrl),
    provideAppInitializer(setDocumentTitle),
    provideAppInitializer(() => inject(AuthService).init()),
    MessageService,
  ],
};
